import React, { useEffect } from 'react'
import { Divider, Text } from '@chakra-ui/react'
import classNames from 'classnames'
import { useStores } from 'hooks/useStores'
import colors from 'theme/colors.theme'
import { getValidArray } from 'utils/common'
import { ERouteName, SidebarItem } from '../../constants'
import MenuItem from '../MenuItem'
import { useLocation } from 'react-router-dom'

interface IAppMenuItemProps {
  item: SidebarItem
  index: number
  isCondensed: boolean
  isBasicUser: boolean
}

const AppMenuItem = ({ item, index, isCondensed, isBasicUser }: IAppMenuItemProps) => {
  const location = useLocation()
  const isActive = location?.pathname.includes(item.path)
  const children = item?.children
  const { organizationStore } = useStores()
  const isLightSideBar: boolean = organizationStore?.organization?.isLightSideBar ?? false

  return (
    <React.Fragment key={`${item.path}-${index}-fragment`}>
      {item?.header && (
        <li
          className="side-nav-title side-nav-item"
          key={`${index}-header`}
          style={{ color: isLightSideBar ? '#1A202C' : 'white' }}
        >
          {item.header}
        </li>
      )}
      {isBasicUser || item.name === ERouteName.DASHBOARD ? (
        <MenuItem
          item={item}
          className={classNames({
            'mm-active': isActive
          })}
          linkClassName={classNames('side-nav-link')}
          isCondensed={isCondensed}
        />
      ) : (
        <>
          {children && !isCondensed && (
            <Text
              margin="20px 16px 8px 12px"
              fontFamily="Inter"
              fontSize="xs"
              fontWeight={600}
              fontStyle="normal"
              color={isLightSideBar ? colors.gray[400] : colors.whiteAlpha[600]}
              lineHeight="normal"
              letterSpacing="1.2px"
            >
              {item.name.toUpperCase()}
            </Text>
          )}
          {isCondensed && (
            <Divider borderColor={`${isLightSideBar ? 'gray.500' : 'whiteAlpha.500'}`} marginLeft={4} width={10} />
          )}
          {getValidArray(children).map((child, index) => {
            return (
              <MenuItem
                key={`${index}`}
                item={child}
                className={classNames('side-nav-item', {
                  'mm-active': isActive && window?.location?.pathname.includes(child.path)
                })}
                linkClassName={classNames('side-nav-link', {
                  'dashboard-margin': item.name === ERouteName.DASHBOARD
                })}
                isCondensed={isCondensed}
              />
            )
          })}
        </>
      )}
    </React.Fragment>
  )
}

export default AppMenuItem
